var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bsh-confirm-modal',{attrs:{"modal_id":_vm.modal_id,"title":_vm.title,"message":_vm.message,"btn":_vm.btn,"btnStyle":_vm.btnStyle},on:{"action":function($event){return _vm.action()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }